import styled from 'styled-components';

const ImageContainer = styled.div`
  cursor: default !important;
  margin-top: 24px;
  height: 100px;

  img {
    max-height: 100%;
  }
`;

interface ImagePreviewArgs {
  imageURI: string;
  imageAlt: string;
}
export const ImagePreview = ({ imageURI, imageAlt }: ImagePreviewArgs) => {
  return (
    <ImageContainer>
      <img src={imageURI} alt={imageAlt} />
    </ImageContainer>
  );
};
